import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import axios from "axios";
import "./index.scss";
const FlowDesign = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const formData = new URLSearchParams();
    formData.append("j_username", "admin");
    formData.append("j_password", "test");
    formData.append("_spring_security_remember_me", true);
    formData.append("submit", "Login");
    axios.post("/flowable-idm/app/authentication", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    var processIframe = document.getElementById("processIframe");
    processIframe.addEventListener("load", function () {
      setLoading(false);
      var nav = processIframe.contentWindow.document.getElementById("main-nav");
      nav.children[0].children[0].click();
    });
  }, []);

  return (
    <div className="flowDesign">
      {loading && (
        <div className="flowDesign-loading">
          <Spin size="large" />
        </div>
      )}
      <iframe
        className={loading ? "iframeLoading" : "iframeShow"}
        id="processIframe"
        src={"/flowable-modeler/#/processes"}
        style={{ width: "100%", height: "850px", border: "1px solid #dfdfdf" }}
      ></iframe>
    </div>
  );
};

export default FlowDesign;
